import React, { act, useEffect, useMemo, useState } from 'react';
import { arrayRemove, arrayUnion, collection, doc, onSnapshot, setDoc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';
import ArrowBack from '../components/arrowBack';

export default function GroupsManager() {

  return (
    <div style={({ display: "flex", gap: "40px", margin: "3%", width: "97%", marginTop: "20px" })}>
    </div>
  );
}
